import type { CurrentUser, Order } from '@arbuz/shared';
import { makeT } from '../i18n';
import { haptic } from '../tg';
import { BottomAction, SummaryRow } from './clientUi';

export function OrderSuccess({
  user,
  order,
  onOrders,
  onHome,
}: {
  user: CurrentUser;
  order: Order;
  onOrders: () => void;
  onHome: () => void;
}) {
  const t = makeT(user.locale);

  return (
    <main className="client-page with-bottom-bar client-success">
      <div className="client-confetti" aria-hidden="true">
        <i />
        <i />
        <i />
        <i />
        <i />
        <i />
        <i />
      </div>

      <div className="client-check" aria-hidden="true">
        ✓
      </div>

      <h1 className="h1">{t('orderAccepted')}</h1>
      <p className="muted" style={{ maxWidth: 280, margin: 'var(--s-3) auto var(--s-6)' }}>
        {t('orderAcceptedText')}
      </p>

      <article className="client-card client-summary-card" style={{ textAlign: 'left' }}>
        <SummaryRow icon="location" label={t('addressTitle')}>
          {order.address_text}
        </SummaryRow>
        <SummaryRow icon="calendar" label={t('slotTitle')}>
          {order.slot_date}
          <br />
          {order.slot_start}–{order.slot_end}
        </SummaryRow>
        <SummaryRow icon="watermelon" label={t('quantityTitle')}>
          {order.items.reduce((sum, item) => sum + item.qty, 0)} {t('pcs')}
        </SummaryRow>
        <SummaryRow icon="order" label={t('orderNumber')}>
          #{order.public_number}
        </SummaryRow>
      </article>

      <BottomAction transparent>
        <button
          type="button"
          className="btn-primary"
          style={{ width: '100%' }}
          onClick={() => {
            haptic('light');
            onOrders();
          }}
        >
          {t('toMyOrders')}
        </button>
        <button type="button" className="client-ghost-button" onClick={onHome}>
          {t('toHome')}
        </button>
      </BottomAction>
    </main>
  );
}
